import React from 'react';
import {
  Router as DefaultRouter,
  Route,
  Switch,
  StaticRouter,
} from 'react-router-dom';
import dynamic from 'umi/dynamic';
import renderRoutes from 'umi/lib/renderRoutes';
import history from '@@/history';
import RendererWrapper0 from '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/.umi-production/LocaleWrapper.jsx';
import { routerRedux, dynamic as _dvaDynamic } from 'dva';

const Router = routerRedux.ConnectedRouter;

const routes = [
  {
    path: '/ums-demo',
    name: 'UMSDemo',
    component: __IS_BROWSER
      ? _dvaDynamic({
          app: require('@tmp/dva').getApp(),
          models: () => [
            import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
              m => {
                return { namespace: 'dialogList', ...m.default };
              },
            ),
            import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
              m => {
                return { namespace: 'dialogRadar', ...m.default };
              },
            ),
            import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
              m => {
                return { namespace: 'newCustomRule', ...m.default };
              },
            ),
          ],
          component: () => import(/* webpackChunkName: "p__Demo" */ '../Demo'),
          LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
            .default,
        })
      : require('../Demo').default,
    exact: true,
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: __IS_BROWSER
      ? _dvaDynamic({
          app: require('@tmp/dva').getApp(),
          models: () => [
            import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
              m => {
                return { namespace: 'dialogList', ...m.default };
              },
            ),
            import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
              m => {
                return { namespace: 'dialogRadar', ...m.default };
              },
            ),
            import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
              m => {
                return { namespace: 'newCustomRule', ...m.default };
              },
            ),
          ],
          component: () =>
            import(/* webpackChunkName: "p__Privacy" */ '../Privacy'),
          LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
            .default,
        })
      : require('../Privacy').default,
    exact: true,
  },
  {
    path: '/user',
    component: __IS_BROWSER
      ? _dvaDynamic({
          component: () =>
            import(/* webpackChunkName: "layouts__BlankLayout" */ '../../layouts/BlankLayout'),
          LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
            .default,
        })
      : require('../../layouts/BlankLayout').default,
    routes: [
      {
        path: '/user',
        redirect: '/user/login',
        exact: true,
      },
      {
        name: '登录',
        icon: 'smile',
        path: '/user/login',
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                  m => {
                    return { namespace: 'dialogList', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                  m => {
                    return { namespace: 'dialogRadar', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                  m => {
                    return { namespace: 'newCustomRule', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__user__login" */ '../user/login'),
              LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                .default,
            })
          : require('../user/login').default,
        exact: true,
      },
      {
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                  m => {
                    return { namespace: 'dialogList', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                  m => {
                    return { namespace: 'dialogRadar', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                  m => {
                    return { namespace: 'newCustomRule', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__exception__404" */ '../exception/404'),
              LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                .default,
            })
          : require('../exception/404').default,
        exact: true,
      },
    ],
  },
  {
    path: '/',
    component: __IS_BROWSER
      ? _dvaDynamic({
          component: () =>
            import(/* webpackChunkName: "layouts__BasicLayout" */ '../../layouts/BasicLayout'),
          LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
            .default,
        })
      : require('../../layouts/BasicLayout').default,
    routes: [
      {
        name: '工作台',
        path: '/workbench',
        disabledTooltip: true,
        routes: [
          {
            path: '/workbench/index',
            name: '首页',
            icon: 'icon-zhuye',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__FirstPage" */ '../FirstPage'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../FirstPage').default,
            hideHeader: true,
            exact: true,
          },
          {
            name: '集团监控',
            icon: 'icon-jituanjiankong',
            path: '/workbench/groupMonitor',
            routes: [
              {
                name: '集团质量监控',
                path: '/workbench/groupMonitor/quality',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                          m => {
                            return { namespace: 'dialogList', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                          m => {
                            return { namespace: 'dialogRadar', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                          m => {
                            return { namespace: 'newCustomRule', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../screen/quality'),
                      LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../screen/quality').default,
                hideHeader: true,
                exact: true,
              },
              {
                name: '预警处理监控',
                path: '/workbench/groupMonitor/alert',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                          m => {
                            return { namespace: 'dialogList', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                          m => {
                            return { namespace: 'dialogRadar', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                          m => {
                            return { namespace: 'newCustomRule', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../screen/alert'),
                      LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../screen/alert').default,
                hideHeader: true,
                exact: true,
              },
              {
                path: '/workbench/groupMonitor/statistics',
                name: '自助报表',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                          m => {
                            return { namespace: 'dialogList', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                          m => {
                            return { namespace: 'dialogRadar', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                          m => {
                            return { namespace: 'newCustomRule', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../report/statistics'),
                      LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../report/statistics').default,
                hideHeader: true,
                exact: true,
              },
              {
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                          m => {
                            return { namespace: 'dialogList', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                          m => {
                            return { namespace: 'dialogRadar', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                          m => {
                            return { namespace: 'newCustomRule', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../render'),
                      LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../render').default,
                exact: true,
              },
            ],
          },
          {
            name: '质检分析',
            icon: 'icon-zhijianfenxi',
            path: '/workbench/qcAnalysis',
            routes: [
              {
                name: '质检总览',
                path: '/workbench/qcAnalysis/stats',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__data__stats__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/data/stats/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                          m => {
                            return { namespace: 'dialogList', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                          m => {
                            return { namespace: 'dialogRadar', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                          m => {
                            return { namespace: 'newCustomRule', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../data/stats'),
                      LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../data/stats').default,
                hideHeader: true,
                exact: true,
              },
              {
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                          m => {
                            return { namespace: 'dialogList', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                          m => {
                            return { namespace: 'dialogRadar', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                          m => {
                            return { namespace: 'newCustomRule', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../render'),
                      LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../render').default,
                exact: true,
              },
            ],
          },
          {
            name: '实时风险分析',
            icon: 'icon-shishifengxianfenxi',
            path: '/workbench/riskAnalysis',
            routes: [
              {
                name: '实时会话监控',
                path: '/workbench/riskAnalysis/dialog',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__monitor__customerMonitor__model.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/monitor/customerMonitor/model.tsx').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                          m => {
                            return { namespace: 'dialogList', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                          m => {
                            return { namespace: 'dialogRadar', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                          m => {
                            return { namespace: 'newCustomRule', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../monitor/customerMonitor'),
                      LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../monitor/customerMonitor').default,
                hideHeader: true,
                exact: true,
              },
              {
                name: '组长实时监控',
                path: '/workbench/riskAnalysis/abnormals',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__monitor__abnormals__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/monitor/abnormals/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                          m => {
                            return { namespace: 'dialogList', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                          m => {
                            return { namespace: 'dialogRadar', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                          m => {
                            return { namespace: 'newCustomRule', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../monitor/abnormals'),
                      LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../monitor/abnormals').default,
                hideHeader: true,
                tip: '仅有下级的账号可使用',
                exact: true,
              },
              {
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                          m => {
                            return { namespace: 'dialogList', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                          m => {
                            return { namespace: 'dialogRadar', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                          m => {
                            return { namespace: 'newCustomRule', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../render'),
                      LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../render').default,
                exact: true,
              },
            ],
          },
        ],
      },
      {
        name: '服务分析',
        path: '/serviceAnalysis',
        disabledTooltip: true,
        routes: [
          {
            name: 'VOC 分析',
            icon: 'icon-VOCfenxi',
            path: '/serviceAnalysis/voc',
            routes: [
              {
                name: '商品咨询热点',
                path: '/serviceAnalysis/voc/hot',
                hideHeader: true,
                routes: [
                  {
                    name: '咨询原声详情',
                    path: '/serviceAnalysis/voc/hot/trt',
                    component: __IS_BROWSER
                      ? _dvaDynamic({
                          app: require('@tmp/dva').getApp(),
                          models: () => [
                            import(/* webpackChunkName: 'p__voc__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/voc/model.ts').then(
                              m => {
                                return { namespace: 'model', ...m.default };
                              },
                            ),
                            import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                              m => {
                                return {
                                  namespace: 'dialogList',
                                  ...m.default,
                                };
                              },
                            ),
                            import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                              m => {
                                return {
                                  namespace: 'dialogRadar',
                                  ...m.default,
                                };
                              },
                            ),
                            import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                              m => {
                                return {
                                  namespace: 'newCustomRule',
                                  ...m.default,
                                };
                              },
                            ),
                          ],
                          component: () =>
                            import(/* webpackChunkName: "layouts__BasicLayout" */ '../voc/trt'),
                          LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                            .default,
                        })
                      : require('../voc/trt').default,
                    exact: true,
                  },
                  {
                    name: '自助洞察分析',
                    path: '/serviceAnalysis/voc/hot/insight',
                    component: __IS_BROWSER
                      ? _dvaDynamic({
                          app: require('@tmp/dva').getApp(),
                          models: () => [
                            import(/* webpackChunkName: 'p__voc__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/voc/model.ts').then(
                              m => {
                                return { namespace: 'model', ...m.default };
                              },
                            ),
                            import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                              m => {
                                return {
                                  namespace: 'dialogList',
                                  ...m.default,
                                };
                              },
                            ),
                            import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                              m => {
                                return {
                                  namespace: 'dialogRadar',
                                  ...m.default,
                                };
                              },
                            ),
                            import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                              m => {
                                return {
                                  namespace: 'newCustomRule',
                                  ...m.default,
                                };
                              },
                            ),
                          ],
                          component: () =>
                            import(/* webpackChunkName: "layouts__BasicLayout" */ '../voc/insight'),
                          LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                            .default,
                        })
                      : require('../voc/insight').default,
                    hideHeader: true,
                    exact: true,
                  },
                  {
                    name: '咨询场景管理',
                    path: '/serviceAnalysis/voc/hot/scene',
                    component: __IS_BROWSER
                      ? _dvaDynamic({
                          app: require('@tmp/dva').getApp(),
                          models: () => [
                            import(/* webpackChunkName: 'p__voc__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/voc/model.ts').then(
                              m => {
                                return { namespace: 'model', ...m.default };
                              },
                            ),
                            import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                              m => {
                                return {
                                  namespace: 'dialogList',
                                  ...m.default,
                                };
                              },
                            ),
                            import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                              m => {
                                return {
                                  namespace: 'dialogRadar',
                                  ...m.default,
                                };
                              },
                            ),
                            import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                              m => {
                                return {
                                  namespace: 'newCustomRule',
                                  ...m.default,
                                };
                              },
                            ),
                          ],
                          component: () =>
                            import(/* webpackChunkName: "layouts__BasicLayout" */ '../voc/scene'),
                          LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                            .default,
                        })
                      : require('../voc/scene').default,
                    hideHeader: true,
                    exact: true,
                  },
                  {
                    component: __IS_BROWSER
                      ? _dvaDynamic({
                          app: require('@tmp/dva').getApp(),
                          models: () => [
                            import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                              m => {
                                return {
                                  namespace: 'dialogList',
                                  ...m.default,
                                };
                              },
                            ),
                            import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                              m => {
                                return {
                                  namespace: 'dialogRadar',
                                  ...m.default,
                                };
                              },
                            ),
                            import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                              m => {
                                return {
                                  namespace: 'newCustomRule',
                                  ...m.default,
                                };
                              },
                            ),
                          ],
                          component: () =>
                            import(/* webpackChunkName: "layouts__BasicLayout" */ '../render'),
                          LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                            .default,
                        })
                      : require('../render').default,
                    exact: true,
                  },
                ],
              },
              {
                name: '商品流失分析',
                path: '/serviceAnalysis/voc/analysis',
                hideHeader: true,
                routes: [
                  {
                    name: '流失原因分析',
                    path: '/serviceAnalysis/voc/analysis/result',
                    component: __IS_BROWSER
                      ? _dvaDynamic({
                          app: require('@tmp/dva').getApp(),
                          models: () => [
                            import(/* webpackChunkName: 'p__voc__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/voc/model.ts').then(
                              m => {
                                return { namespace: 'model', ...m.default };
                              },
                            ),
                            import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                              m => {
                                return {
                                  namespace: 'dialogList',
                                  ...m.default,
                                };
                              },
                            ),
                            import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                              m => {
                                return {
                                  namespace: 'dialogRadar',
                                  ...m.default,
                                };
                              },
                            ),
                            import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                              m => {
                                return {
                                  namespace: 'newCustomRule',
                                  ...m.default,
                                };
                              },
                            ),
                          ],
                          component: () =>
                            import(/* webpackChunkName: "layouts__BasicLayout" */ '../voc/result'),
                          LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                            .default,
                        })
                      : require('../voc/result').default,
                    hideHeader: true,
                    hideInMenu: true,
                    exact: true,
                  },
                  {
                    name: '流失原因分析-doris',
                    path: '/voc/analysis/dorisresult',
                    component: __IS_BROWSER
                      ? _dvaDynamic({
                          app: require('@tmp/dva').getApp(),
                          models: () => [
                            import(/* webpackChunkName: 'p__voc__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/voc/model.ts').then(
                              m => {
                                return { namespace: 'model', ...m.default };
                              },
                            ),
                            import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                              m => {
                                return {
                                  namespace: 'dialogList',
                                  ...m.default,
                                };
                              },
                            ),
                            import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                              m => {
                                return {
                                  namespace: 'dialogRadar',
                                  ...m.default,
                                };
                              },
                            ),
                            import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                              m => {
                                return {
                                  namespace: 'newCustomRule',
                                  ...m.default,
                                };
                              },
                            ),
                          ],
                          component: () =>
                            import(/* webpackChunkName: "layouts__BasicLayout" */ '../voc/doris_result'),
                          LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                            .default,
                        })
                      : require('../voc/doris_result').default,
                    hideHeader: true,
                    hideInMenu: true,
                    exact: true,
                  },
                  {
                    name: '流失配置管理',
                    path: '/serviceAnalysis/voc/analysis/configure',
                    component: __IS_BROWSER
                      ? _dvaDynamic({
                          app: require('@tmp/dva').getApp(),
                          models: () => [
                            import(/* webpackChunkName: 'p__voc__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/voc/model.ts').then(
                              m => {
                                return { namespace: 'model', ...m.default };
                              },
                            ),
                            import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                              m => {
                                return {
                                  namespace: 'dialogList',
                                  ...m.default,
                                };
                              },
                            ),
                            import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                              m => {
                                return {
                                  namespace: 'dialogRadar',
                                  ...m.default,
                                };
                              },
                            ),
                            import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                              m => {
                                return {
                                  namespace: 'newCustomRule',
                                  ...m.default,
                                };
                              },
                            ),
                          ],
                          component: () =>
                            import(/* webpackChunkName: "layouts__BasicLayout" */ '../voc/configure'),
                          LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                            .default,
                        })
                      : require('../voc/configure').default,
                    hideHeader: true,
                    exact: true,
                  },
                  {
                    name: '商品流失详情',
                    path: '/serviceAnalysis/voc/analysis/detail',
                    component: __IS_BROWSER
                      ? _dvaDynamic({
                          app: require('@tmp/dva').getApp(),
                          models: () => [
                            import(/* webpackChunkName: 'p__voc__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/voc/model.ts').then(
                              m => {
                                return { namespace: 'model', ...m.default };
                              },
                            ),
                            import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                              m => {
                                return {
                                  namespace: 'dialogList',
                                  ...m.default,
                                };
                              },
                            ),
                            import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                              m => {
                                return {
                                  namespace: 'dialogRadar',
                                  ...m.default,
                                };
                              },
                            ),
                            import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                              m => {
                                return {
                                  namespace: 'newCustomRule',
                                  ...m.default,
                                };
                              },
                            ),
                          ],
                          component: () =>
                            import(/* webpackChunkName: "layouts__BasicLayout" */ '../voc/detail'),
                          LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                            .default,
                        })
                      : require('../voc/detail').default,
                    exact: true,
                  },
                  {
                    name: '商品流失详情-doris',
                    path: '/voc/analysis/dorisdetail',
                    component: __IS_BROWSER
                      ? _dvaDynamic({
                          app: require('@tmp/dva').getApp(),
                          models: () => [
                            import(/* webpackChunkName: 'p__voc__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/voc/model.ts').then(
                              m => {
                                return { namespace: 'model', ...m.default };
                              },
                            ),
                            import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                              m => {
                                return {
                                  namespace: 'dialogList',
                                  ...m.default,
                                };
                              },
                            ),
                            import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                              m => {
                                return {
                                  namespace: 'dialogRadar',
                                  ...m.default,
                                };
                              },
                            ),
                            import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                              m => {
                                return {
                                  namespace: 'newCustomRule',
                                  ...m.default,
                                };
                              },
                            ),
                          ],
                          component: () =>
                            import(/* webpackChunkName: "layouts__BasicLayout" */ '../voc/doris_detail'),
                          LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                            .default,
                        })
                      : require('../voc/doris_detail').default,
                    exact: true,
                  },
                  {
                    name: '商品管理',
                    path: '/serviceAnalysis/voc/analysis/goods',
                    component: __IS_BROWSER
                      ? _dvaDynamic({
                          app: require('@tmp/dva').getApp(),
                          models: () => [
                            import(/* webpackChunkName: 'p__voc__goods__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/voc/goods/model.ts').then(
                              m => {
                                return { namespace: 'model', ...m.default };
                              },
                            ),
                            import(/* webpackChunkName: 'p__voc__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/voc/model.ts').then(
                              m => {
                                return { namespace: 'model', ...m.default };
                              },
                            ),
                            import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                              m => {
                                return {
                                  namespace: 'dialogList',
                                  ...m.default,
                                };
                              },
                            ),
                            import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                              m => {
                                return {
                                  namespace: 'dialogRadar',
                                  ...m.default,
                                };
                              },
                            ),
                            import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                              m => {
                                return {
                                  namespace: 'newCustomRule',
                                  ...m.default,
                                };
                              },
                            ),
                          ],
                          component: () =>
                            import(/* webpackChunkName: "layouts__BasicLayout" */ '../voc/goods'),
                          LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                            .default,
                        })
                      : require('../voc/goods').default,
                    hideHeader: true,
                    exact: true,
                  },
                  {
                    component: __IS_BROWSER
                      ? _dvaDynamic({
                          app: require('@tmp/dva').getApp(),
                          models: () => [
                            import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                              m => {
                                return {
                                  namespace: 'dialogList',
                                  ...m.default,
                                };
                              },
                            ),
                            import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                              m => {
                                return {
                                  namespace: 'dialogRadar',
                                  ...m.default,
                                };
                              },
                            ),
                            import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                              m => {
                                return {
                                  namespace: 'newCustomRule',
                                  ...m.default,
                                };
                              },
                            ),
                          ],
                          component: () =>
                            import(/* webpackChunkName: "layouts__BasicLayout" */ '../render'),
                          LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                            .default,
                        })
                      : require('../render').default,
                    exact: true,
                  },
                ],
              },
              {
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                          m => {
                            return { namespace: 'dialogList', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                          m => {
                            return { namespace: 'dialogRadar', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                          m => {
                            return { namespace: 'newCustomRule', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../render'),
                      LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../render').default,
                exact: true,
              },
            ],
          },
          {
            name: 'VOC AI',
            icon: 'icon-a-VOCAIbannerguanggaokuaisutiaozhuanye',
            path: '/serviceAnalysis/vocai',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__voc__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/voc/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__voc__vocai" */ '../voc/vocai'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../voc/vocai').default,
            exact: true,
          },
          {
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__render" */ '../render'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../render').default,
            exact: true,
          },
        ],
      },
      {
        name: '质检管理',
        path: '/qcManage',
        disabledTooltip: true,
        routes: [
          {
            name: '质检方案',
            icon: 'icon-zhijianfangan',
            path: '/qcManage/standard',
            routes: [
              {
                name: '质检标准',
                path: '/qcManage/standard/list',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__standard__list__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/standard/list/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__standard__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/standard/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                          m => {
                            return { namespace: 'dialogList', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                          m => {
                            return { namespace: 'dialogRadar', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                          m => {
                            return { namespace: 'newCustomRule', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../standard/list'),
                      LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../standard/list').default,
                hideHeader: true,
                exact: true,
              },
              {
                name: '质检项管理',
                path: '/qcManage/standard/management',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__standard__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/standard/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                          m => {
                            return { namespace: 'dialogList', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                          m => {
                            return { namespace: 'dialogRadar', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                          m => {
                            return { namespace: 'newCustomRule', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../standard/management/_layout'),
                      LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../standard/management/_layout').default,
                hideHeader: true,
                exact: true,
              },
              {
                name: '编辑规则',
                path: '/qcManage/standard/list/edit/:id',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__standard__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/standard/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                          m => {
                            return { namespace: 'dialogList', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                          m => {
                            return { namespace: 'dialogRadar', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                          m => {
                            return { namespace: 'newCustomRule', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../standard/edit'),
                      LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../standard/edit').default,
                hideInMenu: true,
                hideHeader: true,
                exact: true,
              },
            ],
          },
          {
            name: '告警推送设置',
            path: '/qcManage/alarm',
            icon: 'icon-gaojingtuisongshezhi',
            hideHeader: true,
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__alarm__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/alarm/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__alarm" */ '../alarm'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../alarm').default,
            exact: true,
          },
          {
            name: '日志',
            path: '/qcManage/logs',
            icon: 'icon-rizhi',
            hideHeader: true,
            routes: [
              {
                name: '质检标准修订记录',
                path: '/qcManage/logs/standardLog',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__standard__log__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/standard/log/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__standard__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/standard/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                          m => {
                            return { namespace: 'dialogList', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                          m => {
                            return { namespace: 'dialogRadar', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                          m => {
                            return { namespace: 'newCustomRule', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../standard/log'),
                      LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../standard/log').default,
                exact: true,
              },
              {
                name: '消除识别记录',
                path: '/qcManage/logs/eliminateLabels',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__system__eliminateLabels__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/system/eliminateLabels/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__system__models__snick.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/system/models/snick.ts').then(
                          m => {
                            return { namespace: 'snick', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                          m => {
                            return { namespace: 'dialogList', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                          m => {
                            return { namespace: 'dialogRadar', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                          m => {
                            return { namespace: 'newCustomRule', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../system/eliminateLabels'),
                      LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../system/eliminateLabels').default,
                hideHeader: true,
                exact: true,
              },
            ],
          },
        ],
      },
      {
        name: '任务中心',
        path: '/task',
        disabledTooltip: true,
        routes: [
          {
            name: '会话原声',
            icon: 'icon-huihuayuansheng',
            path: '/task/dialog',
            routes: [
              {
                name: '质检会话列表',
                path: '/task/dialog/list',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                          m => {
                            return { namespace: 'dialogList', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                          m => {
                            return { namespace: 'dialogRadar', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                          m => {
                            return { namespace: 'newCustomRule', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../dialog/list'),
                      LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../dialog/list').default,
                hideHeader: true,
                exact: true,
              },
              {
                name: '历史会话查询',
                path: '/task/dialog/history',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__dialog__history__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/dialog/history/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                          m => {
                            return { namespace: 'dialogList', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                          m => {
                            return { namespace: 'dialogRadar', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                          m => {
                            return { namespace: 'newCustomRule', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../dialog/history'),
                      LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../dialog/history').default,
                hideHeader: true,
                exact: true,
              },
              {
                name: '高级搜索设置',
                path: '/task/dialog/radar',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                          m => {
                            return { namespace: 'dialogList', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                          m => {
                            return { namespace: 'dialogRadar', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                          m => {
                            return { namespace: 'newCustomRule', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../dialog/radar'),
                      LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../dialog/radar').default,
                hideInMenu: true,
                hideHeader: true,
                exact: true,
              },
              {
                name: '高级搜索设置',
                path: '/task/dialog/radar/:id',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                          m => {
                            return { namespace: 'dialogList', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                          m => {
                            return { namespace: 'dialogRadar', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                          m => {
                            return { namespace: 'newCustomRule', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../dialog/radar'),
                      LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../dialog/radar').default,
                hideInMenu: true,
                hideHeader: true,
                exact: true,
              },
            ],
          },
          {
            name: '人工质检',
            icon: 'icon-rengongzhijian',
            path: '/task/check',
            routes: [
              {
                name: '质检任务列表',
                path: '/task/check/task',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__check__task__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/check/task/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                          m => {
                            return { namespace: 'dialogList', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                          m => {
                            return { namespace: 'dialogRadar', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                          m => {
                            return { namespace: 'newCustomRule', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../check/task'),
                      LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../check/task').default,
                hideHeader: true,
                exact: true,
              },
              {
                name: '质检任务详情',
                path: '/task/check/task/detail/:id',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__check__detail__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/check/detail/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                          m => {
                            return { namespace: 'dialogList', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                          m => {
                            return { namespace: 'dialogRadar', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                          m => {
                            return { namespace: 'newCustomRule', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../check/detail'),
                      LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../check/detail').default,
                hideInMenu: true,
                hideHeader: true,
                exact: true,
              },
              {
                name: '质检任务记录',
                path: '/task/check/record',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__check__record__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/check/record/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                          m => {
                            return { namespace: 'dialogList', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                          m => {
                            return { namespace: 'dialogRadar', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                          m => {
                            return { namespace: 'newCustomRule', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../check/record'),
                      LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../check/record').default,
                hideHeader: true,
                exact: true,
              },
              {
                name: '质检任务详情',
                path: '/task/check/record/detail/:id',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__check__detail__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/check/detail/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                          m => {
                            return { namespace: 'dialogList', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                          m => {
                            return { namespace: 'dialogRadar', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                          m => {
                            return { namespace: 'newCustomRule', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../check/detail'),
                      LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../check/detail').default,
                hideInMenu: true,
                hideHeader: true,
                exact: true,
              },
              {
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                          m => {
                            return { namespace: 'dialogList', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                          m => {
                            return { namespace: 'dialogRadar', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                          m => {
                            return { namespace: 'newCustomRule', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../render'),
                      LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../render').default,
                exact: true,
              },
            ],
          },
          {
            name: '案例管理',
            icon: 'icon-anliguanli1',
            path: '/task/case',
            routes: [
              {
                name: '会话案例',
                path: '/task/case/dialog',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__case__dialog__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/case/dialog/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                          m => {
                            return { namespace: 'dialogList', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                          m => {
                            return { namespace: 'dialogRadar', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                          m => {
                            return { namespace: 'newCustomRule', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../case/dialog'),
                      LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../case/dialog').default,
                hideHeader: true,
                exact: true,
              },
              {
                name: '审批详情',
                path: '/task/case/approve/detail/:id',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__case__approve__detail__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/case/approve/detail/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__case__approve__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/case/approve/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                          m => {
                            return { namespace: 'dialogList', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                          m => {
                            return { namespace: 'dialogRadar', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                          m => {
                            return { namespace: 'newCustomRule', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../case/approve/detail'),
                      LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../case/approve/detail').default,
                hideHeader: true,
                hideInMenu: true,
                exact: true,
              },
              {
                name: '审批中心',
                path: '/task/case/approve',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__case__approve__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/case/approve/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                          m => {
                            return { namespace: 'dialogList', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                          m => {
                            return { namespace: 'dialogRadar', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                          m => {
                            return { namespace: 'newCustomRule', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../case/approve'),
                      LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../case/approve').default,
                hideHeader: true,
                exact: true,
              },
              {
                name: '案例标签管理',
                path: '/task/case/label',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__system__caseLabel__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/system/caseLabel/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__system__models__snick.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/system/models/snick.ts').then(
                          m => {
                            return { namespace: 'snick', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                          m => {
                            return { namespace: 'dialogList', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                          m => {
                            return { namespace: 'dialogRadar', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                          m => {
                            return { namespace: 'newCustomRule', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../system/caseLabel'),
                      LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../system/caseLabel').default,
                hideHeader: true,
                exact: true,
              },
            ],
          },
          {
            name: '质培管理',
            path: '/task/train',
            icon: 'icon-zhipeiguanli',
            routes: [
              {
                name: '质培任务',
                icon: 'iconshape-2-line',
                path: '/task/train/tasks',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__train__tasks__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/train/tasks/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                          m => {
                            return { namespace: 'dialogList', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                          m => {
                            return { namespace: 'dialogRadar', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                          m => {
                            return { namespace: 'newCustomRule', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../train/tasks'),
                      LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../train/tasks').default,
                exact: true,
              },
              {
                name: '质培任务详情',
                path: '/task/train/detail/:id',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                          m => {
                            return { namespace: 'dialogList', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                          m => {
                            return { namespace: 'dialogRadar', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                          m => {
                            return { namespace: 'newCustomRule', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../train/detail'),
                      LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../train/detail').default,
                hideHeader: true,
                hideInMenu: true,
                exact: true,
              },
              {
                name: '质培任务分析',
                path: '/task/train/analyse',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__data__analyse__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/data/analyse/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                          m => {
                            return { namespace: 'dialogList', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                          m => {
                            return { namespace: 'dialogRadar', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                          m => {
                            return { namespace: 'newCustomRule', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../data/analyse'),
                      LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../data/analyse').default,
                hideHeader: true,
                exact: true,
              },
              {
                name: '场景标签管理',
                path: '/task/train/sceneLabel',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__system__sceneLabel__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/system/sceneLabel/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__system__models__snick.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/system/models/snick.ts').then(
                          m => {
                            return { namespace: 'snick', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                          m => {
                            return { namespace: 'dialogList', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                          m => {
                            return { namespace: 'dialogRadar', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                          m => {
                            return { namespace: 'newCustomRule', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../system/sceneLabel'),
                      LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../system/sceneLabel').default,
                hideHeader: true,
                exact: true,
              },
              {
                name: 'AI 训练场',
                path: '/task/train/aiTrainning',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                          m => {
                            return { namespace: 'dialogList', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                          m => {
                            return { namespace: 'dialogRadar', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                          m => {
                            return { namespace: 'newCustomRule', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../train/aiTrain'),
                      LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../train/aiTrain').default,
                exact: true,
              },
            ],
          },
          {
            name: '质检申诉',
            icon: 'icon-zhijianshensu',
            path: '/task/appeal',
            routes: [
              {
                name: '我的申诉',
                path: '/task/appeal/myself',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__appeal__myself__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/appeal/myself/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                          m => {
                            return { namespace: 'dialogList', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                          m => {
                            return { namespace: 'dialogRadar', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                          m => {
                            return { namespace: 'newCustomRule', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../appeal/myself'),
                      LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../appeal/myself').default,
                hideHeader: true,
                exact: true,
              },
              {
                name: '主管申诉处理',
                path: '/task/appeal/charge',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__appeal__charge__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/appeal/charge/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                          m => {
                            return { namespace: 'dialogList', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                          m => {
                            return { namespace: 'dialogRadar', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                          m => {
                            return { namespace: 'newCustomRule', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../appeal/charge'),
                      LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../appeal/charge').default,
                hideHeader: true,
                exact: true,
              },
              {
                name: '质检员申诉处理',
                path: '/task/appeal/quality',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__appeal__quality__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/appeal/quality/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                          m => {
                            return { namespace: 'dialogList', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                          m => {
                            return { namespace: 'dialogRadar', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                          m => {
                            return { namespace: 'newCustomRule', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../appeal/quality'),
                      LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../appeal/quality').default,
                hideHeader: true,
                exact: true,
              },
              {
                name: '任务详情',
                path: '/task/appeal/detail/:id',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                          m => {
                            return { namespace: 'dialogList', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                          m => {
                            return { namespace: 'dialogRadar', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                          m => {
                            return { namespace: 'newCustomRule', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../appeal/detail'),
                      LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../appeal/detail').default,
                hideHeader: true,
                hideInMenu: true,
                exact: true,
              },
            ],
          },
        ],
      },
      {
        name: '系统管理',
        path: '/system',
        tip: '系统管理不区分平台',
        hidePlatform: true,
        routes: [
          {
            name: '店铺管理',
            icon: 'icon-dianpuguanli',
            path: '/system/shop',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__system__shop__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/system/shop/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__system__models__snick.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/system/models/snick.ts').then(
                      m => {
                        return { namespace: 'snick', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__system__shop" */ '../system/shop'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../system/shop').default,
            tip: '',
            hideHeader: true,
            exact: true,
          },
          {
            name: '子账号管理',
            icon: 'icon-zizhanghaoguanli',
            path: '/system/department',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__system__department__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/system/department/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__system__models__snick.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/system/models/snick.ts').then(
                      m => {
                        return { namespace: 'snick', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__system__department" */ '../system/department'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../system/department').default,
            tip: '',
            hideHeader: true,
            exact: true,
          },
          {
            name: '人员管理',
            icon: 'icon-renyuanguanli',
            path: '/system/snick',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__system__models__snick.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/system/models/snick.ts').then(
                      m => {
                        return { namespace: 'snick', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__system__snick" */ '../system/snick'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../system/snick').default,
            tip: '',
            hideHeader: true,
            exact: true,
          },
          {
            name: '角色权限管理',
            icon: 'icon-jiaosequanxianguanli',
            path: '/system/role',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__system__role__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/system/role/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__system__models__snick.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/system/models/snick.ts').then(
                      m => {
                        return { namespace: 'snick', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__system__role" */ '../system/role'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../system/role').default,
            tip: '',
            hideHeader: true,
            exact: true,
          },
          {
            name: '组织架构设置',
            icon: 'icon-zuzhijiagoushezhi',
            path: '/system/org',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__system__org__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/system/org/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__system__models__snick.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/system/models/snick.ts').then(
                      m => {
                        return { namespace: 'snick', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__system__org" */ '../system/org'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../system/org').default,
            tip: '',
            hideHeader: true,
            exact: true,
          },
          {
            name: '案例标签管理',
            path: '/system/caseLabel',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__system__caseLabel__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/system/caseLabel/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__system__models__snick.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/system/models/snick.ts').then(
                      m => {
                        return { namespace: 'snick', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__system__caseLabel" */ '../system/caseLabel'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../system/caseLabel').default,
            hideHeader: true,
            exact: true,
          },
          {
            name: '场景标签管理',
            path: '/system/sceneLabel',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__system__sceneLabel__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/system/sceneLabel/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__system__models__snick.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/system/models/snick.ts').then(
                      m => {
                        return { namespace: 'snick', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__system__sceneLabel" */ '../system/sceneLabel'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../system/sceneLabel').default,
            hideHeader: true,
            exact: true,
          },
          {
            name: '消除识别记录',
            path: '/system/eliminateLabels',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__system__eliminateLabels__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/system/eliminateLabels/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__system__models__snick.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/system/models/snick.ts').then(
                      m => {
                        return { namespace: 'snick', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__system__eliminateLabels" */ '../system/eliminateLabels'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../system/eliminateLabels').default,
            hideHeader: true,
            exact: true,
          },
        ],
      },
      {
        name: '企业管理',
        icon: 'icon-renyuanguanli',
        path: '/company',
        routes: [
          {
            path: '/company',
            redirect: '/company/manage',
            exact: true,
          },
          {
            name: '企业管理',
            icon: 'icontime',
            path: '/company/manage',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__company__manage__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/company/manage/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__company__manage" */ '../company/manage'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../company/manage').default,
            hideHeader: true,
            exact: true,
          },
          {
            name: '店铺管理',
            path: '/company/shop/:id',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__company__shop__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/company/shop/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__company__shop" */ '../company/shop'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../company/shop').default,
            hideInMenu: true,
            hideHeader: true,
            exact: true,
          },
        ],
      },
      {
        name: '账单管理',
        path: '/bill',
        hideInMenu: true,
        hideHeader: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                  m => {
                    return { namespace: 'dialogList', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                  m => {
                    return { namespace: 'dialogRadar', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                  m => {
                    return { namespace: 'newCustomRule', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__bill" */ '../bill'),
              LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                .default,
            })
          : require('../bill').default,
        exact: true,
      },
      {
        name: 'VOC.AI 报表',
        icon: 'icon-wenzhang',
        path: '/voc_ai_reportConfig',
        routes: [
          {
            path: '/voc_ai_reportConfig',
            redirect: '/voc_ai_reportConfig/configuration',
            exact: true,
          },
          {
            name: '报表配置',
            path: '/voc_ai_reportConfig/configuration',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__report__statisticsVocAi__vocAIConfigPage" */ '../report/statisticsVocAi/vocAIConfigPage'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../report/statisticsVocAi/vocAIConfigPage').default,
            hideHeader: true,
            exact: true,
          },
          {
            path: '/voc_ai_reportConfig/statistics',
            name: 'VOC AI数据洞察',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__report__statisticsVocAi__insight" */ '../report/statisticsVocAi/insight'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../report/statisticsVocAi/insight').default,
            hideHeader: true,
            exact: true,
          },
        ],
      },
      {
        name: '质检报表',
        icon: 'icon-wenzhang',
        path: '/reportConfig',
        routes: [
          {
            path: '/reportConfig',
            redirect: '/reportConfig/configuration',
            exact: true,
          },
          {
            name: '报表配置',
            path: '/reportConfig/configuration',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__report__statistics__configPage" */ '../report/statistics/configPage'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../report/statistics/configPage').default,
            hideHeader: true,
            exact: true,
          },
          {
            path: '/reportConfig/statistics',
            name: '自助报表',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__report__statistics" */ '../report/statistics'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../report/statistics').default,
            hideHeader: true,
            exact: true,
          },
          {
            path: '/reportConfig/voc',
            name: 'VOC洞察报表',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__voc__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/voc/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__voc__insight" */ '../voc/insight'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../voc/insight').default,
            hideHeader: true,
            exact: true,
          },
        ],
      },
      {
        path: '/',
        redirect: '/workbench/index',
        exact: true,
      },
      {
        path: '/workbench/index',
        name: '首页',
        icon: 'icon-shouye1',
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                  m => {
                    return { namespace: 'dialogList', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                  m => {
                    return { namespace: 'dialogRadar', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                  m => {
                    return { namespace: 'newCustomRule', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__FirstPage" */ '../FirstPage'),
              LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                .default,
            })
          : require('../FirstPage').default,
        hideHeader: true,
        exact: true,
      },
      {
        name: '数据大屏',
        icon: 'iconbar-chart-box-line',
        path: '/screen',
        routes: [
          {
            path: '/screen',
            redirect: '/screen/quality',
            exact: true,
          },
          {
            name: '集团质量监控',
            path: '/screen/quality',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__screen__quality" */ '../screen/quality'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../screen/quality').default,
            hideHeader: true,
            exact: true,
          },
          {
            name: '预警处理监控',
            path: '/screen/alert',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__screen__alert" */ '../screen/alert'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../screen/alert').default,
            hideHeader: true,
            exact: true,
          },
        ],
      },
      {
        name: '数据监控',
        icon: 'iconbar-chart-box-line',
        path: '/data',
        routes: [
          {
            name: '质检总览',
            path: '/data/stats',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__data__stats__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/data/stats/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__data__stats" */ '../data/stats'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../data/stats').default,
            hideHeader: true,
            exact: true,
          },
          {
            name: '质培任务分析',
            path: '/data/analyse',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__data__analyse__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/data/analyse/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__data__analyse" */ '../data/analyse'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../data/analyse').default,
            hideHeader: true,
            exact: true,
          },
          {
            name: '实时会话监控',
            path: '/data/dialog',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__monitor__customerMonitor__model.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/monitor/customerMonitor/model.tsx').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__monitor__customerMonitor" */ '../monitor/customerMonitor'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../monitor/customerMonitor').default,
            hideHeader: true,
            exact: true,
          },
          {
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__render" */ '../render'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../render').default,
            exact: true,
          },
        ],
      },
      {
        name: '套购推荐分析',
        icon: 'icon-shangpu',
        path: '/meidi',
        routes: [
          {
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__render" */ '../render'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../render').default,
            exact: true,
          },
        ],
      },
      {
        name: '套购推荐分析',
        icon: 'icon-shangpu',
        path: '/meidi2',
        routes: [
          {
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__render" */ '../render'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../render').default,
            exact: true,
          },
        ],
      },
      {
        name: '拼多多报表数据',
        icon: 'icon-shangpu',
        path: '/pddReports',
        routes: [
          {
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__render" */ '../render'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../render').default,
            exact: true,
          },
        ],
      },
      {
        name: 'VOC',
        icon: 'icon-zhuanshi',
        path: '/voc',
        routes: [
          {
            name: '商品咨询热点',
            path: '/voc/hot',
            hideHeader: true,
            routes: [
              {
                name: '咨询原声详情',
                path: '/voc/hot/trt',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__voc__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/voc/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                          m => {
                            return { namespace: 'dialogList', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                          m => {
                            return { namespace: 'dialogRadar', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                          m => {
                            return { namespace: 'newCustomRule', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../voc/trt'),
                      LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../voc/trt').default,
                exact: true,
              },
              {
                name: '自助洞察分析',
                path: '/voc/hot/insight',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__voc__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/voc/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                          m => {
                            return { namespace: 'dialogList', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                          m => {
                            return { namespace: 'dialogRadar', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                          m => {
                            return { namespace: 'newCustomRule', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../voc/insight'),
                      LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../voc/insight').default,
                hideHeader: true,
                exact: true,
              },
              {
                name: '咨询场景管理',
                path: '/voc/hot/scene',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__voc__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/voc/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                          m => {
                            return { namespace: 'dialogList', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                          m => {
                            return { namespace: 'dialogRadar', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                          m => {
                            return { namespace: 'newCustomRule', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../voc/scene'),
                      LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../voc/scene').default,
                hideHeader: true,
                exact: true,
              },
              {
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                          m => {
                            return { namespace: 'dialogList', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                          m => {
                            return { namespace: 'dialogRadar', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                          m => {
                            return { namespace: 'newCustomRule', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../render'),
                      LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../render').default,
                exact: true,
              },
            ],
          },
          {
            name: '商品流失分析',
            path: '/voc/analysis',
            hideHeader: true,
            routes: [
              {
                name: '流失原因分析',
                path: '/voc/analysis/result',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__voc__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/voc/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                          m => {
                            return { namespace: 'dialogList', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                          m => {
                            return { namespace: 'dialogRadar', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                          m => {
                            return { namespace: 'newCustomRule', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../voc/result'),
                      LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../voc/result').default,
                hideHeader: true,
                hideInMenu: true,
                exact: true,
              },
              {
                name: '流失原因分析-doris',
                path: '/voc/analysis/dorisresult',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__voc__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/voc/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                          m => {
                            return { namespace: 'dialogList', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                          m => {
                            return { namespace: 'dialogRadar', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                          m => {
                            return { namespace: 'newCustomRule', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../voc/doris_result'),
                      LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../voc/doris_result').default,
                hideHeader: true,
                hideInMenu: true,
                exact: true,
              },
              {
                name: '流失配置管理',
                path: '/voc/analysis/configure',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__voc__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/voc/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                          m => {
                            return { namespace: 'dialogList', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                          m => {
                            return { namespace: 'dialogRadar', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                          m => {
                            return { namespace: 'newCustomRule', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../voc/configure'),
                      LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../voc/configure').default,
                hideHeader: true,
                exact: true,
              },
              {
                name: '商品流失详情',
                path: '/voc/analysis/detail',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__voc__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/voc/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                          m => {
                            return { namespace: 'dialogList', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                          m => {
                            return { namespace: 'dialogRadar', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                          m => {
                            return { namespace: 'newCustomRule', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../voc/detail'),
                      LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../voc/detail').default,
                exact: true,
              },
              {
                name: '商品流失详情-doris',
                path: '/voc/analysis/dorisdetail',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__voc__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/voc/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                          m => {
                            return { namespace: 'dialogList', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                          m => {
                            return { namespace: 'dialogRadar', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                          m => {
                            return { namespace: 'newCustomRule', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../voc/doris_detail'),
                      LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../voc/doris_detail').default,
                exact: true,
              },
              {
                name: '商品管理',
                path: '/voc/analysis/goods',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__voc__goods__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/voc/goods/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__voc__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/voc/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                          m => {
                            return { namespace: 'dialogList', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                          m => {
                            return { namespace: 'dialogRadar', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                          m => {
                            return { namespace: 'newCustomRule', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../voc/goods'),
                      LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../voc/goods').default,
                hideHeader: true,
                exact: true,
              },
              {
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                          m => {
                            return { namespace: 'dialogList', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                          m => {
                            return { namespace: 'dialogRadar', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                          m => {
                            return { namespace: 'newCustomRule', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../render'),
                      LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../render').default,
                exact: true,
              },
            ],
          },
          {
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__render" */ '../render'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../render').default,
            exact: true,
          },
        ],
      },
      {
        name: '质检方案',
        icon: 'iconfile-shield-2-line',
        path: '/standard',
        routes: [
          {
            path: '/standard',
            redirect: '/standard/list',
            exact: true,
          },
          {
            name: '质检标准',
            path: '/standard/list',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__standard__list__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/standard/list/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__standard__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/standard/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__standard__list" */ '../standard/list'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../standard/list').default,
            hideHeader: true,
            exact: true,
          },
          {
            name: '质检项管理',
            path: '/standard/management',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__standard__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/standard/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__standard__management___layout" */ '../standard/management/_layout'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../standard/management/_layout').default,
            hideHeader: true,
            exact: true,
          },
          {
            name: '标准修订记录',
            path: '/standard/list/log',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__standard__log__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/standard/log/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__standard__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/standard/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__standard__log" */ '../standard/log'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../standard/log').default,
            hideHeader: true,
            hideInMenu: true,
            exact: true,
          },
          {
            name: '编辑规则',
            path: '/standard/list/edit/:id',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__standard__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/standard/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__standard__edit" */ '../standard/edit'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../standard/edit').default,
            hideInMenu: true,
            hideHeader: true,
            exact: true,
          },
        ],
      },
      {
        name: '质检会话',
        icon: 'iconchat-4-line',
        path: '/dialog',
        routes: [
          {
            path: '/dialog',
            redirect: '/dialog/list',
            exact: true,
          },
          {
            name: '质检会话列表',
            path: '/dialog/list',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__dialog__list" */ '../dialog/list'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../dialog/list').default,
            hideHeader: true,
            exact: true,
          },
          {
            name: '历史会话查询',
            path: '/dialog/history',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__dialog__history__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/dialog/history/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__dialog__history" */ '../dialog/history'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../dialog/history').default,
            hideHeader: true,
            exact: true,
          },
          {
            name: '高级搜索设置',
            path: '/dialog/radar',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__dialog__radar" */ '../dialog/radar'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../dialog/radar').default,
            hideInMenu: true,
            hideHeader: true,
            exact: true,
          },
          {
            name: '高级搜索设置',
            path: '/dialog/radar/:id',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__dialog__radar" */ '../dialog/radar'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../dialog/radar').default,
            hideInMenu: true,
            hideHeader: true,
            exact: true,
          },
        ],
      },
      {
        name: '人工质检',
        icon: 'iconuser-follow-line',
        path: '/check',
        routes: [
          {
            path: '/check',
            redirect: '/check/task',
            exact: true,
          },
          {
            name: '质检任务列表',
            path: '/check/task',
            routes: [
              {
                path: '/check/task',
                redirect: '/check/task/list',
                exact: true,
              },
              {
                name: '质检任务',
                path: '/check/task/list',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__check__task__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/check/task/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                          m => {
                            return { namespace: 'dialogList', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                          m => {
                            return { namespace: 'dialogRadar', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                          m => {
                            return { namespace: 'newCustomRule', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../check/task'),
                      LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../check/task').default,
                hideInMenu: true,
                hideHeader: true,
                exact: true,
              },
              {
                name: '质检任务详情',
                path: '/check/task/detail/:id',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__check__detail__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/check/detail/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                          m => {
                            return { namespace: 'dialogList', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                          m => {
                            return { namespace: 'dialogRadar', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                          m => {
                            return { namespace: 'newCustomRule', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../check/detail'),
                      LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../check/detail').default,
                hideInMenu: true,
                hideHeader: true,
                exact: true,
              },
            ],
          },
          {
            name: '质检任务记录',
            path: '/check/record',
            routes: [
              {
                path: '/check/record',
                redirect: '/check/record/list',
                exact: true,
              },
              {
                name: '质检任务记录',
                path: '/check/record/list',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__check__record__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/check/record/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                          m => {
                            return { namespace: 'dialogList', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                          m => {
                            return { namespace: 'dialogRadar', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                          m => {
                            return { namespace: 'newCustomRule', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../check/record'),
                      LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../check/record').default,
                hideInMenu: true,
                hideHeader: true,
                exact: true,
              },
              {
                name: '质检任务详情',
                path: '/check/record/detail/:id',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__check__detail__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/check/detail/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                          m => {
                            return { namespace: 'dialogList', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                          m => {
                            return { namespace: 'dialogRadar', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                          m => {
                            return { namespace: 'newCustomRule', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "layouts__BasicLayout" */ '../check/detail'),
                      LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../check/detail').default,
                hideInMenu: true,
                hideHeader: true,
                exact: true,
              },
            ],
          },
        ],
      },
      {
        name: '质检报表',
        icon: 'iconfile-list-2-line',
        path: '/report',
        hideHeader: true,
        routes: [
          {
            path: '/report',
            redirect: '/report/stat/platform',
            exact: true,
          },
          {
            path: '/report/stat',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__report___layout" */ '../report/_layout'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../report/_layout').default,
            hideInMenu: true,
            routes: [
              {
                path: '/report/stat/platform',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__report__platform__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/report/platform/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                          m => {
                            return { namespace: 'dialogList', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                          m => {
                            return { namespace: 'dialogRadar', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                          m => {
                            return { namespace: 'newCustomRule', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "p__report___layout" */ '../report/platform/list'),
                      LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../report/platform/list').default,
                exact: true,
              },
              {
                path: '/report/stat/shop',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__report__shop__list__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/report/shop/list/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                          m => {
                            return { namespace: 'dialogList', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                          m => {
                            return { namespace: 'dialogRadar', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                          m => {
                            return { namespace: 'newCustomRule', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "p__report___layout" */ '../report/shop/list'),
                      LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../report/shop/list').default,
                exact: true,
              },
              {
                path: '/report/stat/customer',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__report__customer__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/report/customer/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                          m => {
                            return { namespace: 'dialogList', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                          m => {
                            return { namespace: 'dialogRadar', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                          m => {
                            return { namespace: 'newCustomRule', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "p__report___layout" */ '../report/customer/list'),
                      LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../report/customer/list').default,
                exact: true,
              },
            ],
          },
          {
            name: '店铺详情',
            path: '/report/shop/detail',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__report__shop__detail__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/report/shop/detail/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__report__shop__detail" */ '../report/shop/detail'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../report/shop/detail').default,
            hideInMenu: true,
            exact: true,
          },
          {
            name: '客服详情',
            path: '/report/customer/detail',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__report__customer__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/report/customer/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__report__customer__detail__layout" */ '../report/customer/detail/layout'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../report/customer/detail/layout').default,
            hideInMenu: true,
            routes: [
              {
                path: '/report/customer/detail/result',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__report__customer__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/report/customer/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                          m => {
                            return { namespace: 'dialogList', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                          m => {
                            return { namespace: 'dialogRadar', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                          m => {
                            return { namespace: 'newCustomRule', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "p__report__customer__detail__layout" */ '../report/customer/detail/result'),
                      LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../report/customer/detail/result').default,
                exact: true,
              },
              {
                path: '/report/customer/detail/ai',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__report__customer__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/report/customer/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                          m => {
                            return { namespace: 'dialogList', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                          m => {
                            return { namespace: 'dialogRadar', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                          m => {
                            return { namespace: 'newCustomRule', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "p__report__customer__detail__layout" */ '../report/customer/detail/ai'),
                      LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../report/customer/detail/ai').default,
                exact: true,
              },
              {
                path: '/report/customer/detail/man',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      app: require('@tmp/dva').getApp(),
                      models: () => [
                        import(/* webpackChunkName: 'p__report__customer__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/report/customer/model.ts').then(
                          m => {
                            return { namespace: 'model', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                          m => {
                            return { namespace: 'dialogList', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                          m => {
                            return { namespace: 'dialogRadar', ...m.default };
                          },
                        ),
                        import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                          m => {
                            return { namespace: 'newCustomRule', ...m.default };
                          },
                        ),
                      ],
                      component: () =>
                        import(/* webpackChunkName: "p__report__customer__detail__layout" */ '../report/customer/detail/man'),
                      LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../report/customer/detail/man').default,
                exact: true,
              },
            ],
          },
        ],
      },
      {
        name: '案例管理',
        icon: 'iconstack-line',
        path: '/case',
        routes: [
          {
            path: '/case',
            redirect: '/case/dialog',
            exact: true,
          },
          {
            name: '会话案例',
            path: '/case/dialog',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__case__dialog__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/case/dialog/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__case__dialog" */ '../case/dialog'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../case/dialog').default,
            hideHeader: true,
            exact: true,
          },
          {
            name: '审批详情',
            path: '/case/approve/detail/:id',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__case__approve__detail__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/case/approve/detail/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__case__approve__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/case/approve/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__case__approve__detail" */ '../case/approve/detail'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../case/approve/detail').default,
            hideHeader: true,
            hideInMenu: true,
            exact: true,
          },
          {
            name: '审批中心',
            path: '/case/approve',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__case__approve__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/case/approve/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__case__approve" */ '../case/approve'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../case/approve').default,
            hideHeader: true,
            exact: true,
          },
        ],
      },
      {
        name: '质检报表',
        icon: 'iconfile-list-2-line',
        path: '/qcTable',
        routes: [
          {
            path: '/qcTable/statistics',
            name: '自助报表',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__report__statistics" */ '../report/statistics'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../report/statistics').default,
            hideHeader: true,
            exact: true,
          },
          {
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__render" */ '../render'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../render').default,
            exact: true,
          },
        ],
      },
      {
        name: '质检申诉',
        icon: 'iconshape-2-line',
        path: '/appeal',
        routes: [
          {
            path: '/appeal',
            redirect: '/appeal/myself',
            exact: true,
          },
          {
            name: '我的申诉',
            path: '/appeal/myself',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__appeal__myself__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/appeal/myself/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__appeal__myself" */ '../appeal/myself'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../appeal/myself').default,
            hideHeader: true,
            exact: true,
          },
          {
            name: '主管申诉处理',
            path: '/appeal/charge',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__appeal__charge__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/appeal/charge/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__appeal__charge" */ '../appeal/charge'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../appeal/charge').default,
            hideHeader: true,
            exact: true,
          },
          {
            name: '质检员申诉处理',
            path: '/appeal/quality',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__appeal__quality__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/appeal/quality/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__appeal__quality" */ '../appeal/quality'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../appeal/quality').default,
            hideHeader: true,
            exact: true,
          },
          {
            name: '任务详情',
            path: '/appeal/detail/:id',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__appeal__detail" */ '../appeal/detail'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../appeal/detail').default,
            hideHeader: true,
            hideInMenu: true,
            exact: true,
          },
        ],
      },
      {
        name: '质培任务',
        icon: 'iconshape-2-line',
        path: '/train',
        routes: [
          {
            path: '/train',
            redirect: '/train/tasks',
            exact: true,
          },
          {
            name: '任务列表',
            path: '/train/tasks',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__train__tasks__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/train/tasks/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__train__tasks" */ '../train/tasks'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../train/tasks').default,
            hideHeader: true,
            hideInMenu: true,
            exact: true,
          },
          {
            name: '任务详情',
            path: '/train/detail/:id',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__train__detail" */ '../train/detail'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../train/detail').default,
            hideHeader: true,
            hideInMenu: true,
            exact: true,
          },
        ],
      },
      {
        name: '组长监控',
        icon: 'icontime',
        path: '/monitor',
        tip: '仅有下级的账号可使用',
        routes: [
          {
            path: '/monitor',
            redirect: '/monitor/abnormals',
            exact: true,
          },
          {
            name: '实时质检监控',
            path: '/monitor/abnormals',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__monitor__abnormals__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/monitor/abnormals/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__monitor__abnormals" */ '../monitor/abnormals'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../monitor/abnormals').default,
            hideHeader: true,
            exact: true,
          },
        ],
      },
      {
        name: '基础管理',
        icon: 'iconuser-settings-line',
        path: '/system',
        tip: '基础管理不区分平台',
        hidePlatform: true,
        routes: [
          {
            path: '/system',
            redirect: '/system/shop',
            exact: true,
          },
          {
            name: '店铺管理',
            path: '/system/shop',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__system__shop__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/system/shop/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__system__models__snick.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/system/models/snick.ts').then(
                      m => {
                        return { namespace: 'snick', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__system__shop" */ '../system/shop'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../system/shop').default,
            hideHeader: true,
            exact: true,
          },
          {
            name: '子账号管理',
            path: '/system/department',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__system__department__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/system/department/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__system__models__snick.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/system/models/snick.ts').then(
                      m => {
                        return { namespace: 'snick', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__system__department" */ '../system/department'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../system/department').default,
            hideHeader: true,
            exact: true,
          },
          {
            name: '人员管理',
            path: '/system/snick',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__system__models__snick.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/system/models/snick.ts').then(
                      m => {
                        return { namespace: 'snick', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__system__snick" */ '../system/snick'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../system/snick').default,
            hideHeader: true,
            exact: true,
          },
          {
            name: '角色权限管理',
            path: '/system/role',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__system__role__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/system/role/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__system__models__snick.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/system/models/snick.ts').then(
                      m => {
                        return { namespace: 'snick', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__system__role" */ '../system/role'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../system/role').default,
            hideHeader: true,
            exact: true,
          },
          {
            name: '组织架构设置',
            path: '/system/org',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__system__org__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/system/org/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__system__models__snick.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/system/models/snick.ts').then(
                      m => {
                        return { namespace: 'snick', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__system__org" */ '../system/org'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../system/org').default,
            hideHeader: true,
            exact: true,
          },
          {
            name: '案例标签管理',
            path: '/system/caseLabel',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__system__caseLabel__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/system/caseLabel/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__system__models__snick.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/system/models/snick.ts').then(
                      m => {
                        return { namespace: 'snick', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__system__caseLabel" */ '../system/caseLabel'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../system/caseLabel').default,
            hideHeader: true,
            exact: true,
          },
          {
            name: '场景标签管理',
            path: '/system/sceneLabel',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__system__sceneLabel__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/system/sceneLabel/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__system__models__snick.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/system/models/snick.ts').then(
                      m => {
                        return { namespace: 'snick', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__system__sceneLabel" */ '../system/sceneLabel'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../system/sceneLabel').default,
            hideHeader: true,
            exact: true,
          },
          {
            name: '消除识别记录',
            path: '/system/eliminateLabels',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__system__eliminateLabels__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/system/eliminateLabels/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__system__models__snick.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/system/models/snick.ts').then(
                      m => {
                        return { namespace: 'snick', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__system__eliminateLabels" */ '../system/eliminateLabels'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../system/eliminateLabels').default,
            hideHeader: true,
            exact: true,
          },
        ],
      },
      {
        name: '企业管理',
        icon: 'iconuser-settings-line',
        path: '/company',
        routes: [
          {
            path: '/company',
            redirect: '/company/manage',
            exact: true,
          },
          {
            name: '企业管理',
            icon: 'icontime',
            path: '/company/manage',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__company__manage__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/company/manage/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__company__manage" */ '../company/manage'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../company/manage').default,
            hideHeader: true,
            exact: true,
          },
          {
            name: '店铺管理',
            path: '/company/shop/:id',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__company__shop__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/company/shop/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__company__shop" */ '../company/shop'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../company/shop').default,
            hideInMenu: true,
            hideHeader: true,
            exact: true,
          },
        ],
      },
      {
        name: '质检报表',
        icon: 'icon-wenzhang',
        path: '/reportConfig',
        routes: [
          {
            path: '/reportConfig',
            redirect: '/reportConfig/configuration',
            exact: true,
          },
          {
            name: '报表配置',
            path: '/reportConfig/configuration',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__report__statistics__configPage" */ '../report/statistics/configPage'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../report/statistics/configPage').default,
            hideHeader: true,
            exact: true,
          },
          {
            path: '/reportConfig/statistics',
            name: '自助报表',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__report__statistics" */ '../report/statistics'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../report/statistics').default,
            hideHeader: true,
            exact: true,
          },
          {
            path: '/reportConfig/voc',
            name: 'VOC洞察报表',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__voc__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/voc/model.ts').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__voc__insight" */ '../voc/insight'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../voc/insight').default,
            hideHeader: true,
            exact: true,
          },
        ],
      },
      {
        name: '账单管理',
        path: '/bill',
        hideInMenu: true,
        hideHeader: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                  m => {
                    return { namespace: 'dialogList', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                  m => {
                    return { namespace: 'dialogRadar', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                  m => {
                    return { namespace: 'newCustomRule', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__bill" */ '../bill'),
              LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                .default,
            })
          : require('../bill').default,
        exact: true,
      },
      {
        name: 'VOC.AI 报表',
        icon: 'icon-wenzhang',
        path: '/voc_ai_reportConfig',
        routes: [
          {
            path: '/voc_ai_reportConfig',
            redirect: '/voc_ai_reportConfig/configuration',
            exact: true,
          },
          {
            name: '报表配置',
            path: '/voc_ai_reportConfig/configuration',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__report__statisticsVocAi__vocAIConfigPage" */ '../report/statisticsVocAi/vocAIConfigPage'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../report/statisticsVocAi/vocAIConfigPage').default,
            hideHeader: true,
            exact: true,
          },
          {
            path: '/voc_ai_reportConfig/statistics',
            name: 'VOC AI数据洞察',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                      m => {
                        return { namespace: 'dialogList', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                      m => {
                        return { namespace: 'dialogRadar', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                      m => {
                        return { namespace: 'newCustomRule', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__report__statisticsVocAi__insight" */ '../report/statisticsVocAi/insight'),
                  LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                    .default,
                })
              : require('../report/statisticsVocAi/insight').default,
            hideHeader: true,
            exact: true,
          },
        ],
      },
      {
        name: '告警推送',
        path: '/alarm',
        hideInMenu: true,
        hideHeader: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__alarm__model.ts' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/alarm/model.ts').then(
                  m => {
                    return { namespace: 'model', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                  m => {
                    return { namespace: 'dialogList', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                  m => {
                    return { namespace: 'dialogRadar', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                  m => {
                    return { namespace: 'newCustomRule', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__alarm" */ '../alarm'),
              LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                .default,
            })
          : require('../alarm').default,
        exact: true,
      },
      {
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                  m => {
                    return { namespace: 'dialogList', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                  m => {
                    return { namespace: 'dialogRadar', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                  m => {
                    return { namespace: 'newCustomRule', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__render" */ '../render'),
              LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                .default,
            })
          : require('../render').default,
        exact: true,
      },
      {
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__models__dialogList.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogList.tsx').then(
                  m => {
                    return { namespace: 'dialogList', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__models__dialogRadar.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/dialogRadar.tsx').then(
                  m => {
                    return { namespace: 'dialogRadar', ...m.default };
                  },
                ),
                import(/* webpackChunkName: 'p__models__newCustomRule.tsx' */ '/builds/xiaoduo-front/xiaoduo-front-ums/src/pages/models/newCustomRule.tsx').then(
                  m => {
                    return { namespace: 'newCustomRule', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__exception__404" */ '../exception/404'),
              LoadingComponent: require('/builds/xiaoduo-front/xiaoduo-front-ums/src/components/PageLoading/index')
                .default,
            })
          : require('../exception/404').default,
        exact: true,
      },
    ],
  },
];
window.g_routes = routes;
const plugins = require('umi/_runtimePlugin');
plugins.applyForEach('patchRoutes', { initialValue: routes });

export { routes };

export default class RouterWrapper extends React.Component {
  unListen() {}

  constructor(props) {
    super(props);

    // route change handler
    function routeChangeHandler(location, action) {
      plugins.applyForEach('onRouteChange', {
        initialValue: {
          routes,
          location,
          action,
        },
      });
    }
    this.unListen = history.listen(routeChangeHandler);
    // dva 中 history.listen 会初始执行一次
    // 这里排除掉 dva 的场景，可以避免 onRouteChange 在启用 dva 后的初始加载时被多执行一次
    const isDva =
      history.listen
        .toString()
        .indexOf('callback(history.location, history.action)') > -1;
    if (!isDva) {
      routeChangeHandler(history.location);
    }
  }

  componentWillUnmount() {
    this.unListen();
  }

  render() {
    const props = this.props || {};
    return (
      <RendererWrapper0>
        <Router history={history}>{renderRoutes(routes, props)}</Router>
      </RendererWrapper0>
    );
  }
}
